function isValidIban(ibanEntered: string): boolean {
    if (ibanEntered) {
      const ibanUpper = ibanEntered.toUpperCase();
      if (ibanUpper.startsWith('AE') && ibanUpper.length === 23) {
  
        const bank = ibanUpper.substring(4) + ibanUpper.substring(0, 4);
        const asciiShift = 55;
        let checkSumString = '';
  
        for (let i = 0; i < bank.length; i++) {
          const char = bank[i];
          const code = char.charCodeAt(0);
          checkSumString += code > 64 && code < 91 ? code - asciiShift : char;
        }
  
        let checksum = parseInt(checkSumString[0]);
        for (let j = 1; j < checkSumString.length; j++) {
          const digit = parseInt(checkSumString[j]);
          checksum = (checksum * 10 + digit) % 97;
        }
  
        return checksum === 1;
      } else {
        return false;
      }
    } else {
      return true; // No need to check if IBAN is empty
    }
  }
  export default isValidIban